module.exports = __webpack_public_path__ + "img/model_52_ug.2841da63.jpg";